var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGooglePay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.185,
    height: 27.707,
    viewBox: "0 0 27.185 27.707",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "google_pay",
    "data-name": "google pay",
    transform: "translate(-179.78 74.696)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "GPay-Light-themed-buttons",
    transform: "translate(-178.22 -70.696)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "GPAY---SVGs"
  }, /*#__PURE__*/React.createElement("g", {
    id: "GPay-Brand-Mark"
  }, /*#__PURE__*/React.createElement("g", {
    id: "GPay"
  }, /*#__PURE__*/React.createElement("g", {
    id: "G"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10186",
    "data-name": "Group 10186",
    transform: "translate(358 -4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-8",
    d: "M72.181,51a16.485,16.485,0,0,0-.239-2.818H58.864v5.335h7.491a6.409,6.409,0,0,1-2.769,4.21v3.465h4.471A13.545,13.545,0,0,0,72.181,51",
    transform: "translate(-44.996 -36.831)",
    fill: "#4285f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-10",
    d: "M18.66,81.258a13.276,13.276,0,0,0,9.192-3.346l-4.471-3.465a8.411,8.411,0,0,1-12.507-4.392H6.269v3.568A13.87,13.87,0,0,0,18.66,81.258",
    transform: "translate(-4.792 -53.551)",
    fill: "#34a853"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-12",
    d: "M6.082,41.269a8.3,8.3,0,0,1,0-5.3V32.4H1.477a13.837,13.837,0,0,0,0,12.44Z",
    transform: "translate(0 -24.765)",
    fill: "#fabb05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-14",
    d: "M18.66,5.483a7.532,7.532,0,0,1,5.32,2.078v0l3.958-3.954A13.333,13.333,0,0,0,18.66,0,13.868,13.868,0,0,0,6.269,7.632L10.874,11.2A8.294,8.294,0,0,1,18.66,5.483",
    transform: "translate(-4.792)",
    fill: "#e94235"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePay);
export default __webpack_public_path__ + "static/media/google-pay.1eb4021f35720393a1fe5c6bdedefceb.svg";
export { ForwardRef as ReactComponent };